import * as z from "zod";

export const disconnectGorgiasIntegration = {
  name: "disconnectGorgiasIntegration" as const,
  input: z.null(),
  output: z.object({ success: z.boolean() }),
};
